import styled, { css } from 'styled-components';
import theme from '../../../assets/styles/theme';

export const CellWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${({ leftSpacing }) => (
    css`
      margin-left: ${theme.spacing[leftSpacing]}
    `)};
`;
